import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

// update materials
export class BoilerPartService {
  private connection = {
    'name': {
      'index': 'a',
      'value': 'default',
    },
    'type': {
      'index': 'b',
      'value': 'isolatedBlankFlange',
      'options': [
        {
          'value': 'isolatedBlankFlange',
        },
        {
          'value': 'blankFlange',
        },
      ],
    },
    'height': {
      'unit': 'm',
      'index': 'd',
      'value': 0.252,
      'ifType': 'radial',
    },
    'comment': '',
    'location': {
      'index': 'e',
      'value': 'bottom',
      'ifType': 'axial',
      'options': [
        {
          'value': 'bottom',
        },
        {
          'value': 'top',
        },
      ],
    },
    'material': {
      'index': 'f',
      'value': 'ABS',
      'id': 'abs',
      'info': '',
      'company': null,
      'options': [],
    },
    'tubeLength': {
      'unit': 'm',
      'index': 'g',
      'value': 0.065,
      'optional': true,
    },
    'orientation': {
      'index': 'c',
      'value': 'radial',
      'options': [
        {
          'value': 'radial',
        },
        {
          'value': 'axial',
        },
      ],
    },
    'displayAngle': {
      'index': 'j',
      'value': 0,
    },
    'innerDiameter': {
      'unit': 'm',
      'index': 'i',
      'value': 0.045,
    },
    'flangeThickness': {
      'unit': 'm',
      'index': 'i',
      'value': 0.006,
    },
    'tubeWallThickness': {
      'unit': 'm',
      'index': 'h',
      'value': 0.0067,
    },
    'insulationMaterial': {
      'index': 'b',
      'value': 'EPS',
      'ifType': 'isolatedBlankFlange',
      'options': [
        {
          'value': 'Neopor',
        },
        {
          'value': 'EPS',
        },
        {
          'value': 'Styropor',
        },
        {
          'value': 'Steel',
        },
        {
          'value': 'ABS',
        },
      ],
    },
    'flangeOuterDiameter': {
      'unit': 'm',
      'index': 'h',
      'value': 0.06,
    },
    'insulationThickness': {
      'unit': 'm',
      'index': 'b',
      'value': 0.0022,
      'ifType': 'isolatedBlankFlange',
    },
  };

  private heatExchanger = {
    'name': {
      'index': 'a',
      'value': 'hex1',
    },
    'type': {
      'index': 'c',
      'value': 'Electric',
      'options': [
        {
          'value': 'Electric',
        },
      ],
    },
    'power': {
      'unit': 'W',
      'index': 'd',
      'value': 500,
    },
    'comment': {
      'index': 'b',
      'value': 'nohexpresentinCAD.Heightvaluesguessed.',
    },
    'endHeight': {
      'unit': 'm',
      'index': 'f',
      'value': 0.3,
    },
    'startHeight': {
      'unit': 'm',
      'index': 'e',
      'value': 0.15,
    },
  };

  private patch = {
    'area': {
      'unit': 'm^2',
      'index': 'b',
      'value': 0.029,
    },
    'name': {
      'index': 'a',
      'value': 'name1',
    },
    'layer': [
      {
        'material': {
          'value': 'ABS',
          'id': 'abs',
          'info': '',
          'company': null,
          'options': [],
        },
        'thickness': {
          'unit': 'm',
          'value': 0.065,
        },
      },
    ],
    'location': {
      'index': 'g',
      'value': 'bottom',
      'ifType': 'axial',
      'options': [
        {
          'value': 'bottom',
        },
        {
          'value': 'top',
        },
      ],
    },
    'heightMax': {
      'unit': 'm',
      'index': 'e',
      'value': 0.15,
      'ifType': 'radial',
    },
    'heightMin': {
      'unit': 'm',
      'index': 'f',
      'value': 0.15,
      'ifType': 'radial',
    },
    'orientation': {
      'index': 'd',
      'value': 'radial',
      'options': [
        {
          'value': 'radial',
        },
        {
          'value': 'axial',
        },
      ],
    },
    'displayAngle': {
      'index': 'c',
      'value': 80,
    },
  };

  private layer = {
    'material': {
      'value': '',
      'options': [],
    },
    'thickness': {
      'unit': 'm',
      'value': 0.065,
    },
  };

  public setMaterials(materials: any) {
    this.connection.material.options = materials.connections.material;
    this.layer.material.options = materials.patches.material;
    this.patch.layer[0].material.options = materials.patches.material;
  }

  public getPart(name: string) {
    switch (name) {
      case 'connections':
        return this.connection;
      case 'heatExchangers':
        return this.heatExchanger;
      case 'patches':
        return this.patch;
      case 'layer':
        return this.layer;
      default:
        return {};
    }
  }
}
